import Vue from 'vue'
const enable_status = ['auto-attach', 'manual-attach']
const state = {
	tagsRef: null,
	data: {},
	selected: '',
	// selected: [],
	// is_editing_tags: true,
	is_editing_tags: false,
	editing_tag_id: '',
	show_more_tags: {},
	query_sub_tags: [],
}
const mutations = {
	add (state, payload) {
		Vue.set(state.data, [payload.id], payload)
	},
	set (state, payload) {
		Vue.set(state.data, [payload.id], payload)
	},
	remove (state, payload) {
		Vue.delete(state.data, payload.id)
	},
	// set_selected (state, tagId) {
	// 	if (state.selected == tagId) {
	// 		state.selected = ''
	// 	} else {
	// 		state.selected = tagId
	// 	}
	// },
	switch_is_editing_tags (state) {
		state.is_editing_tags = !state.is_editing_tags
	},
	update_editing_tag (state, tag_id) {
		state.editing_tag_id = tag_id
	},
	update_show_more (state, tag_id) {
		Vue.set(state.show_more_tags, [tag_id], true)
	},
	update_hide_more (state, tag_id) {
		Vue.set(state.show_more_tags, [tag_id], false)
	}
}
const getters = {
	/*
	tags_array: (state, _, rootState) => {
		const tags_arr = Object.values(state.data)

		const filterType = rootState.tabs.filterType
		if (filterType !== '') {
			return tags_arr.filter((item) => {
				return (item.hasOwnProperty(filterType) && item[filterType] > 0)
			}).sort((a, b) => {
				return (a[filterType] < b[filterType] ? 1 : -1)
			}).map(tag => {
				tag.count = tag[filterType]
				return tag
			})
		} else {
			return tags_arr.map(item => {
				const deferred = isNaN(item.deferred) ? 0 : item.deferred
				const inbox = isNaN(item.inbox) ? 0 : item.inbox
				const done = isNaN(item.done) ? 0 : item.done
				item.count = deferred + inbox + done
				return item
			}).filter((item) => {
				if (item.count > 0) return true
			}).sort((a, b) => {
				return (a.count < b.count ? 1 : -1)
			})
		}
	},
	*/
	selected: (state => state.selected),
	/*
	is_contained_selected: (state, getters) => {
		const tags = getters.tags_array
		const index = tags.findIndex(tag => tag.id == state.selected)
		return index !== -1 ? true : false
	},
	*/
	tags_counted: (state, _getters, _rootState, rootGetters) => {
		let tags = {}
		const all_tags = state.data

		rootGetters['tabs/current_filtered_tabs'].map((tab) => {
			tab.tags.map((tabTag) => {
				if ( enable_status.includes(tabTag.status) ) {
					if (tags.hasOwnProperty(tabTag.tag_id)) {
						tags[tabTag.tag_id].count += 1
					} else {
						let children = []
						if (all_tags[tabTag.tag_id]) {
							if (all_tags[tabTag.tag_id].children) {
								children = all_tags[tabTag.tag_id].children
							}
						}
						
						tags[tabTag.tag_id] = {
							id: tabTag.tag_id,
							count: 1,
							name: tabTag.name,
							children: children,
						}
					}
				}
			})
		})
		return tags
	},
	tags: (state, getters) => {
		let tags = getters.tags_counted

		const get_tag_by_ids = (ids) => {
			return Object.values(tags).filter(tag => 
				ids.includes(tag.id)
			)
		}

		let filter_tags = []
		const loop_tags = (tags_obj) => {
			
			let res = []
			Object.values(tags_obj).forEach(tag => {
				if (!tag.children) {
					res.push(tag)
					return
				}
				let children = Object.keys(tag.children)
					.filter(key => {
						return tag.children[key] == true
					})

				filter_tags = filter_tags.concat(children)
				
				children = get_tag_by_ids(children)
				children = Object.assign({}, children)
				children = loop_tags(children)
				tag.children_tag = children
				res.push(tag)
			})
			return res.sort((a, b) => {
				return (a.count < b.count ? 1 : -1)
			})
		}

		tags = loop_tags(tags)

		tags = tags.filter(tag => {
			return !(filter_tags.includes(tag.id))
		})

		return tags.sort((a, b) => {
			return (a.count < b.count ? 1 : -1)
		})
	},
	editing_tag: (state) => {
		if (state.editing_tag_id == '') {
			return ''
		}
		return state.data[state.editing_tag_id]
	},
	editing_tag_children(_, getters) {
		if (!getters.editing_tag || !getters.editing_tag.children) {
			return {}
		}
		return getters.editing_tag.children
	},
	tags_obj(state) {
		return state.data
	},
	editing_tag_sub_tags(state, getters) {
		if (state.editing_tag_id == '')  {
			return []
		}
		let tags = JSON.parse(JSON.stringify(getters.tags_obj))
		Object.keys(tags).map((key) => {
			tags[key].is_child = false
		})
		const children = getters.editing_tag_children
		Object.keys(children).map((key) => {
			if (children[key]) {
				tags[key].is_child = true
			} else {
				tags[key].is_child = false
			}
		})

		// 自身は表示させない
		delete tags[state.editing_tag_id]

		tags = Object.values(tags)
			// .sort((a, b) => {
			// 	return a.is_child ? -1 : 1
			// })
		return tags
	},
	show_more_tags(state) {
		return state.show_more_tags
	},
}

const actions = {
	set_selected ({ state, dispatch }, to) {
		state.selected = (state.selected == to) ? '' : to
		dispatch('update_query_sub_tags')
	},
	update_query_sub_tags ({ state }) {
		const selected_tag = state.selected
		if (selected_tag == '') {
			state.query_sub_tags = []
			return
		}
		if (state.data[selected_tag].children) {
			let query_sub_tags = state.data[selected_tag].children
			query_sub_tags = Object.keys(query_sub_tags)
								.filter(key => query_sub_tags[key])
			state.query_sub_tags = query_sub_tags
		} else {
			state.query_sub_tags = []
		}
	},
	init ({ state, rootState }) {
		const uid = rootState.user.uid
		state.tagsRef = rootState.db.collection('users').doc(uid).collection('tags')
	},
	// 1. リスナーの起動
	startListener ({ commit, state }) {
		if (this.tagsUnsubscribe) {
			this.tagsUnsubscribe()
			this.tagsUnsubscribe = null
		}
		// 3. Firestoreからデータを検索する
		const ref = state.tagsRef
		this.tagsUnsubscribe = ref.onSnapshot(querySnapshot => {
			// 6. データが更新されるたびに呼び出される
			querySnapshot.docChanges().forEach(change => {
				// console.log('OnSnapshot tag', change.doc)

				const payload = {
					id: change.doc.id,
					name: change.doc.data().name,
					deferred: change.doc.data().deferred,
					inbox: change.doc.data().inbox,
					done: change.doc.data().done,
					children: change.doc.data().children,
				}

				// 4. ミューテーションを通してステートを更新する
				if (change.type === 'added') {
					commit('add', payload)
				} else if (change.type === 'modified') {
					commit('set', payload)
				} else if (change.type === 'removed') {
					commit('remove', payload)
				}
			})
		},
		(error) => {
			console.error(error.name)
		})
	},
	// 8. リスナーの停止
	stopListener () {
		if (this.tagsUnsubscribe) {
			this.tagsUnsubscribe()
			this.tagsUnsubscribe = null
		}
	},
	update_editing_tag_children ({ state, getters }, tag_id) {
		if (state.editing_tag_id == '') {
			return
		}
		let children = getters.editing_tag.children
		if (children == undefined) {
			children = {}
		}

		if (children[tag_id]) {
			children[tag_id] = !children[tag_id]	
		} else {
			children[tag_id] = true
		}

		state.tagsRef.doc(state.editing_tag_id).update({ 'children': children })
			.then(() => {

			})
			.catch(err => {

			})
	},
}
export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions
}
